import { CurrencyFormatter, RULES_EXCEPTIONS } from '../formatters/CurrencyFormatter';
import type { CurrencyInfo } from '../store/slices/game/types';

import { numberFormatterLocal } from './formatters';

enum Separator {
  Decimal = 'decimal',
  Group = 'group',
}

const getSeparator = (formatter: Intl.NumberFormat, type: Separator): string => {
  const parts = formatter.formatToParts(10000.15);
  const value = parts.find((part) => part.type === type)?.value;

  if (!value) {
    return type === Separator.Decimal ? '.' : ',';
  }

  return value;
};

const getFormatter = (locale: string, currency: string): Intl.NumberFormat => {
  try {
    return new Intl.NumberFormat(numberFormatterLocal(locale), {
      style: 'currency',
      currency,
      currencyDisplay: 'narrowSymbol',
      ...RULES_EXCEPTIONS[currency]
    });
  } catch (e) {
    return new Intl.NumberFormat(numberFormatterLocal(locale), {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 5,
    });
  }
};

// TODO: Ideally this info should be returned from the server
// TODO: not sure group group number is needed at all and is same in different locales
export const getCurrencyInfo = (currency: string, locale: string): CurrencyInfo => {
  const formatter = getFormatter(locale, currency);
  const decimalSeparator = getSeparator(formatter, Separator.Decimal);
  const groupSeparator = getSeparator(formatter, Separator.Group);

  const testNumber = 10000.12;
  const formattedNumber = formatter.format(testNumber);

  const [firstPart, decimals] = formattedNumber.split(decimalSeparator);
  const [rest, group] = firstPart.split(groupSeparator);

  const numberStart = rest?.lastIndexOf('1');
  const symbol = rest?.substring(0, numberStart).trim() || currency;

  return {
    digitsNumber: decimals?.length ?? 0,
    groupNumber: group?.length ?? 0,
    decimalSeparator,
    groupSeparator,
    symbol: CurrencyFormatter.replaceExceptionSymbol(symbol, currency),
  };
};
